import styled from "styled-components";
import { useState } from "react";
import { isProdEnvironment } from "../../env";
import AddressAutoFill from "./AddressAutofill";
import TransferStatus from "./TransferStatus";
import Betterment from "./Betterment";
import { LoginScreen } from "./Login";

const sandboxEnv = ["address-autofill", "transfer-status", "Betterment", "New Login"];

const StyledPage = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledMenu = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
`;

const StyledContent = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Sandbox = () => {
  const [currentEnv, setCurrentEnv] = useState<string>(sandboxEnv[0]);
  if (isProdEnvironment()) return <></>;

  return (
    <StyledPage>
      <StyledMenu>
        {sandboxEnv.map((env) => (
          <button key={env} onClick={() => setCurrentEnv(env)}>
            {env}
          </button>
        ))}
      </StyledMenu>
      <StyledContent>
        {currentEnv === "address-autofill" && <AddressAutoFill />}
        {currentEnv === "transfer-status" && <TransferStatus />}
        {currentEnv === "Betterment" && <Betterment />}
        {currentEnv === "New Login" && <LoginScreen />}
      </StyledContent>
    </StyledPage>
  );
};

export default Sandbox;
